/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InstitutionEditDto
 */
export interface InstitutionEditDto {
    /**
     * 
     * @type {number}
     * @memberof InstitutionEditDto
     */
    idinstitution?: number;
    /**
     * 
     * @type {string}
     * @memberof InstitutionEditDto
     */
    denomination?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InstitutionEditDto
     */
    adresse?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InstitutionEditDto
     */
    codePostal?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InstitutionEditDto
     */
    localite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InstitutionEditDto
     */
    commune?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InstitutionEditDto
     */
    gsm?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InstitutionEditDto
     */
    telephone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InstitutionEditDto
     */
    email?: string | null;
}

/**
 * Check if a given object implements the InstitutionEditDto interface.
 */
export function instanceOfInstitutionEditDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InstitutionEditDtoFromJSON(json: any): InstitutionEditDto {
    return InstitutionEditDtoFromJSONTyped(json, false);
}

export function InstitutionEditDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstitutionEditDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idinstitution': !exists(json, 'idinstitution') ? undefined : json['idinstitution'],
        'denomination': !exists(json, 'denomination') ? undefined : json['denomination'],
        'adresse': !exists(json, 'adresse') ? undefined : json['adresse'],
        'codePostal': !exists(json, 'codePostal') ? undefined : json['codePostal'],
        'localite': !exists(json, 'localite') ? undefined : json['localite'],
        'commune': !exists(json, 'commune') ? undefined : json['commune'],
        'gsm': !exists(json, 'gsm') ? undefined : json['gsm'],
        'telephone': !exists(json, 'telephone') ? undefined : json['telephone'],
        'email': !exists(json, 'email') ? undefined : json['email'],
    };
}

export function InstitutionEditDtoToJSON(value?: InstitutionEditDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idinstitution': value.idinstitution,
        'denomination': value.denomination,
        'adresse': value.adresse,
        'codePostal': value.codePostal,
        'localite': value.localite,
        'commune': value.commune,
        'gsm': value.gsm,
        'telephone': value.telephone,
        'email': value.email,
    };
}

